// src/components/quizzes/kit/bonusVoice.js
//
// The bonus rounds' read-aloud. It used to (a) wait for the child to tap the
// screen AGAIN before saying anything, (b) wait up to 0.8 s for the browser's
// voice list on every sentence, and (c) talk at 0.92 speed. That is the
// "starts talking very late and speaks very slow" complaint.
//
// Now: speak straight away (the child already pressed a button to get to
// the bonus round, so the browser lets us), at 1.15 speed. The cloud voice
// (services/cloudVoice.js) picks these up like every other utterance.

export const BONUS_RATE = 1.15;

const canSpeak = () => typeof window !== "undefined" && "speechSynthesis" in window;

const PREFERRED = [
  /Microsoft .*? (Aria|Jenny|Guy) .*? Online .*? Natural/i,
  /Google US English/i,
  /Samantha/i,
  /Microsoft Zira/i,
];

const bestVoice = () => {
  try {
    const list = window.speechSynthesis.getVoices() || [];
    if (!list.length) return null;
    const saved = localStorage.getItem("ttsVoiceName");
    const mine = saved && list.find((v) => v.name === saved);
    if (mine) return mine;
    for (const p of PREFERRED) {
      const v = list.find((x) => p.test(x.name));
      if (v) return v;
    }
    return list.find((v) => /^en(-|_)?US/i.test(v.lang)) || list.find((v) => /^en/i.test(v.lang)) || null;
  } catch {
    return null;
  }
};

/** Say `text` now (stops anything already being said). */
export const bonusSay = (text, { rate = BONUS_RATE, onStart, onEnd } = {}) => {
  if (!canSpeak() || !text) {
    onEnd?.();
    return;
  }
  try {
    window.speechSynthesis.resume?.();
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(String(text));
    u.lang = "en-US";
    u.rate = rate;
    u.pitch = 1;
    u.volume = 1;
    const v = bestVoice();
    if (v) u.voice = v;
    u.onstart = () => onStart?.();
    u.onend = () => onEnd?.();
    u.onerror = () => onEnd?.();
    window.speechSynthesis.speak(u);
  } catch {
    onEnd?.();
  }
};

export const bonusHush = () => {
  try {
    if (canSpeak()) window.speechSynthesis.cancel();
  } catch {
    /* ignore */
  }
};

export const bonusCanSpeak = canSpeak;
